import React, { useContext, useEffect, useRef } from "react";
import styles from "./Pagination.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
const Pagination = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const refItems = useRef([]);
  const { data, stage } = state;
  useEffect(()=>{
    const items = refItems.current;
    items.forEach((element, index) => {
        if(index === stage){
          element.classList.add(styles.active);
        }else if(index < stage){
          element.classList.remove(styles.active);
          element.classList.add(styles.prev);
        }else{
          element.classList.remove(styles.active);
          element.classList.remove(styles.prev);
        }
    });
  },[stage]);
  return (
    <>
      <div className={styles.wrap}>
        {data.length > 0 ?
          data.map((_, index) => {
            return <div className={styles.item} key={`pag-item-${index}`} ref={element => refItems.current[index] = element}>
              <div className={styles.item__number}>{index + 1}</div>
              <div className={styles.item__bar}></div>
            </div>
          })
          :

          null}
      </div>
    </>
  );

}

export default Pagination;
